import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/css/bootstrap-theme.min.css'; // boostrap@3
// import 'bootstrap/dist/css/bootstrap.css'; //bootstrap@4

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { API_DOMAIN, API_AUTH_TOKEN } from '../../EnvVars';

import ThanksContainer from './ThanksContainer';

class App extends Component {
  constructor(props) {
    super(props);

    this.uuid = null;
    this.rego = null;
    this.authToken = null;
    this.userName = 'sampleClientId';
    this.password = 'secret';
    this.authorization = null;
    this.authToken = null;
    this.status = null;
    this.authTokenUrl = null;
    this.confirmBookingUrl = null;

    this.state = {
      gettingAuthToken: null,
      confirmingBooking: null,
      authToken: null,
      rego: null,
    };

    // this.getURLVars = this.getURLVars.bind(this);
  }

  componentDidMount() {
    this.uuid = this.getURLVars().uuid || 'c0b8aa1d-c392-4707-b0b7-f25e50087c99';
    this.status = this.getURLVars().status || 'whatever_status';
    this.authorization = this.getURLVars().token || 'c2FtcGxlQ2xpZW50SWQ6c2VjcmV0';
    this.rego = this.getURLVars().rego || 'ABC123';

    this.getAuthToken()
      .then(token => {
        // console.log(token);
        this.authToken = token;
        this.setState({
          rego: this.rego,
          gettingAuthToken: false,
        });
        this.postConfirmBooking().then(
          this.setState({
            confirmingBooking: false,
          }),
        );
      })
      .catch(error => console.error(error));
  }

  getURLVars() {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    return vars;
  }

  getAuthToken() {
    this.setState({ gettingAuthToken: true });
    this.authTokenUrl = `${API_AUTH_TOKEN}?grant_type=client_credentials`;

    return fetch(this.authTokenUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${this.authorization}`,
      },
    }).then(response => response.text());
  }

  postConfirmBooking() {
    this.setState({ confirmingBooking: true });
    this.confirmBookingUrl = `${API_DOMAIN}/api/bookingep/undms/updatebooking/uuid/${
      this.uuid
    }/status/${this.status}`;

    return fetch(this.confirmBookingUrl, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: this.authToken,
      },
    }).then(response => response.text());
  }

  render() {
    return (
      <div>
        <ThanksContainer
          rego={this.rego}
          gettingAuthToken={this.state.gettingAuthToken}
          confirmingBooking={this.state.confirmingBooking}
        />
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/containers/Thanks/AppThanks.js